<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Administración"
          directory="Licencias"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="
              () => {
                $hub.$emit('reload-' + tableId);
              }
            "
          >
            <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
          </button>
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getListAction" />
  </div>

</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../../apiUrl";
import { TableHelpers } from "./TableHelpers";

export default {
extends: CoreLibrary,
mixins: [TableHelpers],
data() {
    return {
      tableId: "license-management-table",
      rowData: {},
      options: {
        name: "license-management-table",
        url: `/accreditations/admin/manage-licenses/indexManagement`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("Ver Pago"),
            icon: "edit",
            type: "none",
          },
        ],
        filters: [
          {
              title: "Actividad",
              type: "checkbox",
              key: "accreditation_activity",
              option: [],
          },
          {
            title: this.$t("Filtrar por fechas"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days"],
          },
        ],
        showFilter: true,
        showSearch: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  watch: {
    "$store.state.accreditation.accAppOptions": function () {
      this.searchAndSelectFilterOptions();
    },
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  methods: {
    data() {
      this.$store.dispatch("getAccAppOptions");
    },
    searchAndSelectFilterOptions() {
      
      const area = this.options.filters.find(
          (element) => element.key === "accreditation_activity"
      );
      area.option =
          this.$store.state.accreditation.accAppOptions.accreditationActivities;

    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Ver Pago") {
        let url = rowData.license_payment_file;
        if (url) {
          const w = window.open(url.path, "_blank");
          w.focus();
        } else {
          this.$toastr.e(this.$t("No se pudo encontar el archivo"));
        }
      }
    }
  },
}
</script>

<style>

</style>